import { Component, input } from '@angular/core';
import { SharedModule } from '@app/modules/shared.module';
import { Diversification, FirstDA } from '@app/models/carnet-liaison';
import {
  getDiversificationGroupsKeyed,
  getFirstDate,
  formatFirstDate,
} from '../../carnet-liaison.utils';

@Component({
  selector: 'app-carnet-diversification',
  templateUrl: './carnet-diversification.component.html',
  styleUrl: './carnet-diversification.component.scss',
  standalone: true,
  imports: [SharedModule],
})
export class CarnetDiversificationComponent {
  data = input<Diversification | null>(null);
  firstDA = input<FirstDA | null>(null);
  selectedDate = input<Date | null>(null);

  formatFirstDate = formatFirstDate;

  getGroups() {
    return getDiversificationGroupsKeyed(this.data(), this.firstDA(), this.selectedDate());
  }

  getFirstDate(theme: string, optionKey: string): string | null {
    return getFirstDate(this.firstDA(), 'DA_diversification', theme, optionKey);
  }
}
